import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";


export default function Profile() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(6);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size
  const token = localStorage.getItem("token");

  const [user, setUser] = useState([]);
  const [email, setEmail] = useState('')
  const [companyName, setcompanyName] = useState('')
  const [Phone, setPhone] = useState('')
  const [Address, setAddress] = useState('')
  const [image, setImage] = useState('')
  const [ci, setCi] = useState('')  // Holds the current image URL
  const [oldPassword, setOldPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [count,setCount] = useState(0)

  const [allShipsReg, setallShipsReg] = useState([]);
const [newShip, setNewShip] = useState(
  JSON.parse(localStorage.getItem("newShip")) || false
);
const [prevShipCount, setPrevShipCount] = useState(
  JSON.parse(localStorage.getItem("prevShipCount")) || 0
);

useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res1.data.status === 200) {
        const fetchedShips = res1.data.data.reverse();
        const currentShipCount = fetchedShips.length;

        // Check if a new ship was added AFTER the last seen count
        if (currentShipCount > prevShipCount) {
          setNewShip(true);
          localStorage.setItem("newShip", JSON.stringify(true));
          localStorage.setItem("prevShipCount", JSON.stringify(currentShipCount));
        }

        setallShipsReg(fetchedShips);
      }
    } catch (error) {
      console.log(error);
    }
  }

  fetchData();

  // Polling every 5 seconds
  const interval = setInterval(fetchData, 5000);

  return () => clearInterval(interval);
}, [prevShipCount]); // Only depend on prevShipCount to avoid unnecessary updates

const handleView = () => {
  setNewShip(false);
  localStorage.setItem("newShip", JSON.stringify(false));
  setPrevShipCount(allShipsReg.length);
  localStorage.setItem("prevShipCount", JSON.stringify(allShipsReg.length));
};

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(`${config.base_url}/api/HappyMarineShipping/users/admin`, {
          headers: {
            "Content-Type": "application/json",
            
          },
        });

        if (res.data.status === 200) {
            console.log(res)
          setUser(res.data.data);
          setcompanyName(res.data.data.company_name)
          setEmail(res.data.data.email)
          setPhone(res.data.data.phone)
          setAddress(res.data.data.address)
          setCi(`${config.base_url}${res.data.data.image}`); 
          
        } else {
          console.log("API response error:", res);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [config.base_url,token,count]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleSubmit = async (id) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('company_name', companyName);
    formData.append('email', email);
    formData.append('phone', Phone);
    formData.append('address', Address);
    if (oldPassword && NewPassword) {
        formData.append('old_password', oldPassword);
        formData.append('new_password', NewPassword);
    }
    if (image) {
        formData.append('image', image); // Append file object
    }

    try {
        const response = await axios.put(
            `${config.base_url}/api/HappyMarineShipping/user/update`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Token ${token}`,
                },
            }
        );

        if (response.data.status === 200) {
          setCount(id)
            setLoading(false);
            toast.success("User Updated Successfully!", {
                autoClose: 1500,
                position: 'top-right',
            });
        } else {
            setLoading(false);
            toast.error(response.data.message || "Fill the required fields", {
                autoClose: 1500,
                position: "top-right",
            });
        }
    } catch (err) {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred", {
            autoClose: 1500,
            position: "top-right",
        });
    }
};

  const [loading,setLoading] = useState('')

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };



  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  

 


  const [allSubCategory, setallSubCategory] = useState([]);
  
  const {id} = useParams()

  const [CategoryTitle,setCategoryTitle] = useState('');
  const [Category,setCategory] = useState('')
  const [SubCategoryDescription,setSubCategoryDescription] = useState('')
  const navigate = useNavigate()

 

 
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}
         
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={'/admin/profile'}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
       {/* Sidebar */}
                              <div
                                className={`${
                                  isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
                                }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
                              >
                                <ul className="mt-10 flex flex-col gap-3 ">
                                  {/* Dashboard */}
                                  <li className="px-4 py-2 text-lg   flex items-center">
                                    <i className="fa-solid fa-gauge mr-3"></i>
                                    {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                                  </li>
                      
                                  {isSidebarOpen && <div className="px-5 mt-2 w-[75%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                      
                                  {/* Ship For Sale Dropdown */}
                                  <li className="px-2   text-lg  flex flex-col  relative">
                                    <div
                                      className="flex items-center  justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                                    >
                                      <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                       <h1 className="text-xl text-center font-semibold">-</h1>
                                        {isSidebarOpen && <span>Ship For Sale</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 1 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addShip">Add Ships</Link>
                                          </li>
                                          <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/viewShip">View Ships</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 1
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addShip">Add Ships</Link>
                                          </li>
                                          <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                            <Link to="/admin/viewShip">View Ships</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                  <li className="px-2  text-lg  flex flex-col relative">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                        <h1 className="text-xl text-center font-semibold">-</h1>
                                        {isSidebarOpen && <span>Ship For Charter</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                                    {!isSidebarOpen && openDropdown === 2 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addCharter">Add Charter</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/shipforCharter">View Charter</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 2
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addCharter">Add Charter</Link>
                                          </li>
                                          <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/shipforCharter">View Charter</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                   <li className="px-2  text-lg flex flex-col relative group ">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                         <h1 className="text-xl text-center font-semibold">-</h1>
                                        {isSidebarOpen && <span>Open Cargo </span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 3 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to='/admin/addcargo'>Add Cargo</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                             <Link to='/admin/viewCargo' >View Cargo</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 3
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to='/admin/addcargo'>Add Cargo</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                             <Link to='/admin/viewCargo' >View Cargo</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                  <li className="px-2 py-2 text-lg flex flex-col relative group ">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                         <h1 className="text-xl text-center font-semibold">-</h1>
                                        {isSidebarOpen && <span>Supply Equipments </span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 4 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addsEq">Add Equipments</Link>
                                          </li>
                                          <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/shipforEq">View Equipments</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 4
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addsEq">Add Equipments</Link>
                                          </li>
                                          <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/shipforEq">View Equipments</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                   
                                 {isSidebarOpen && (
                                        <div className="px-5 mt-2 w-[75%]">
                                          <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                            Approvals
                                          </h1>
                                        </div>
                                      )}
                                      {isSidebarOpen && (
                                        <ul className="px-2  text-lg flex flex-col relative group">
                                          <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforsale"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ships For Sale
                                            </Link>
                                            {newShip && (
                                              <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                New
                                              </span>
                                            )}
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforCharterApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Ship For Charter
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                            to='/admin/LogisticsAppr'
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Open Cargo
                                            </Link>
                                          </li>
                          
                                          <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                            <Link
                                              to="/admin/shipforEqApp"
                                              onClick={() => handleView()} // Ensure it runs before navigation
                                            >
                                              - Supply Equipments
                                            </Link>
                                          </li>
                                        </ul>
                                      )}
                      
                                  {/* Settings Dropdown */}
                                  <li className="px-3 py-2 text-lg text-[#00c292] border-l-4 border-[#00c292]  flex flex-col relative group">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                                      onClick={() => toggleDropdown(6)}
                                    >
                                      <div className="flex items-center gap-2">
                                        <i className="fa-solid fa-gear"></i>
                                        {isSidebarOpen && <span>Settings</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {/* Hover Dropdown (Closed Sidebar) */}
                                    {!isSidebarOpen && openDropdown === 6 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                        <ul>
                                          <li className="px-4 py-2 hover:bg-gray-100">
                                            <Link to="/admin/profile">Profile</Link>
                                          </li>
                                          <li className="px-4 py-2 hover:bg-gray-100">
                                          <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Click Dropdown (Open Sidebar) */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 6
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/profile">Profile</Link>
                                          </li>
                                          <li className="px-3 py-1 hover:text-[#00c292]">
                                           <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                                </ul>
                              </div>
                      
                              {/* mobile screen sidebar */}
                      
                              <div
                                className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
                                  isMobile
                                    ? isSidebarOpen
                                      ? "w-full translate-x-0" // Open in full width on mobile
                                      : "-translate-x-full w-0" // Hide sidebar on mobile
                                    : isSidebarOpen
                                    ? "w-60 translate-x-0" // Open normally on desktop
                                    : "w-0" // Hide sidebar on desktop
                                }`}
                              >
                                <ul className="mt-10 flex flex-col gap-3 ">
                                  {/* Dashboard */}
                                  <li className={`px-4 py-2 text-lg    flex items-center`}>
                                    {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
                                    {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
                                  </li>
                      
                      {isSidebarOpen && <div className="px-5  w-[50%]"><h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">Registrations</h1></div>}
                                  {/* Ship For Sale Dropdown */}
                                  <li
                                    className={`px-2  text-lg  flex flex-col  relative`}
                                  >
                                    <div
                                      className="flex items-center  justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
                                    >
                                      <div className="flex items-center  gap-2 hover:text-[#00c292]">
                                        {isSidebarOpen && <h1 className="text-xl text-center font-semibold">-</h1>}
                                        {isSidebarOpen && <span>Ship For Sale</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 1 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addShip">Add Ships</Link>
                                          </li>
                                          <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/viewShip">View Ships</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 1
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addShip">Add Ships</Link>
                                          </li>
                                          <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                                            <Link to="/admin/viewShip">View Ships</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                  <li className="px-3  text-lg  flex flex-col relative">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(2)} // Toggle Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                        {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                        {isSidebarOpen && <span>Ship For Charter</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                                    {!isSidebarOpen && openDropdown === 2 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addCharter">Add Charter</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/shipforCharter">View Charter</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 2
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/addCharter">Add Charter</Link>
                                          </li>
                                          <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                                            <Link to="/admin/shipforCharter">View Charter</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                   <li className="px-3  text-lg flex flex-col relative group ">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                        {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                        {isSidebarOpen && <span>Open Cargo</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 3 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to='/admin/addcargo'>Add Cargo</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                             <Link to='/admin/viewCargo' >View Cargo</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 3
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to='/admin/addcargo'>Add Cargo</Link>
                                          </li>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                             <Link to='/admin/viewCargo' >View Cargo</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                  <li className="px-3  text-lg  flex flex-col relative group ">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2"
                                      onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
                                    >
                                      <div className="flex items-center hover:text-[#00c292] gap-2">
                                        {isSidebarOpen &&  <h1 className="text-xl text-center font-semibold">-</h1>}
                                        {isSidebarOpen && <span>Supply Equipments</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {!isSidebarOpen && openDropdown === 4 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addsEq">Add Equipments</Link>
                                          </li>
                                          <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                            <Link to="/admin/shipforEq">View Equipments</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Dropdown Content */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 4
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-1 py-1 w-full hover:text-[#00c292]">
                                            <Link to="/admin/addsEq">Add Equipments</Link>
                                          </li>
                                          <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                                            <Link to="/admin/shipforEq">View Equipments</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                      
                                  <li className="px-3 text-lg flex flex-col relative group">
                                                   {/* Clickable Div */}
                                                   {isSidebarOpen && (
                                                     <div className="px-5  w-[50%]">
                                                       <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                                                         Approvals
                                                       </h1>
                                                     </div>
                                                   )}
                                     
                                                   {isSidebarOpen && (
                                                     <ul
                                                       className="px-2 py-2  text-lg flex gap-3
                                                                                                                    flex-col relative group"
                                                     >
                                                       <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforsale"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ships For Sale
                                                         </Link>
                                                         {newShip && (
                                                           <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                             New
                                                           </span>
                                                         )}
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforCharterApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Ship For Charter
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                         to='/admin/LogisticsAppr'
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Open Cargo
                                                         </Link>
                                                       </li>
                                     
                                                       <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                                                         <Link
                                                           to="/admin/shipforEqApp"
                                                           onClick={() => handleView()} // Ensure it runs before navigation
                                                         >
                                                           - Supply Equipments
                                                         </Link>
                                                       </li>
                                                     </ul>
                                                   )}
                                     
                                                   {/* Click Dropdown (For open sidebar) */}
                                                   {isSidebarOpen && (
                                                     <div
                                                       className={`ml-6 mt-2 transition-all duration-300 ${
                                                         openDropdown === 5
                                                           ? "max-h-48 opacity-100 "
                                                           : "max-h-0 opacity-0 overflow-hidden"
                                                       }`}
                                                     >
                                                       <ul>
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforsale"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ships For Sale
                                                           </Link>
                                                           {newShip && (
                                                             <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                                                               New
                                                             </span>
                                                           )}
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforCharterApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Ship For Charter
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                           to='/admin/LogisticsAppr'
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Open Cargo
                                                           </Link>
                                                         </li>
                                     
                                                         <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                                                           <Link
                                                             to="/admin/shipforEqApp"
                                                             onClick={() => handleView()} // Ensure it runs before navigation
                                                           >
                                                             - Supply Equipments
                                                           </Link>
                                                         </li>
                                                       </ul>
                                                     </div>
                                                   )}
                                                 </li>
               
                      
                      
                                  {/* Settings Dropdown */}
                                  <li className="px-3  text-[#00c292] border-l-4 border-[#00c292] text-lg flex flex-col relative group">
                                    <div
                                      className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                                      onClick={() => toggleDropdown(6)}
                                    >
                                      <div className="flex items-center gap-2">
                                        {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                                        {isSidebarOpen && <span>Settings</span>}
                                      </div>
                                      {isSidebarOpen && (
                                        <i
                                          className={`fa-solid ${
                                            openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                                          }`}
                                        ></i>
                                      )}
                                    </div>
                      
                                    {/* Hover Dropdown (Closed Sidebar) */}
                                    {!isSidebarOpen && openDropdown === 6 && (
                                      <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                                        <ul>
                                          <li className="px-4 py-2 hover:bg-gray-100">
                                            <Link to="/admin/profile">Profile</Link>
                                          </li>
                                          <li className="px-3 py-1 hover:text-[#00c292]">
                                           <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                      
                                    {/* Click Dropdown (Open Sidebar) */}
                                    {isSidebarOpen && (
                                      <div
                                        className={`ml-6 mt-2 transition-all duration-300 ${
                                          openDropdown === 6
                                            ? "max-h-40 opacity-100"
                                            : "max-h-0 opacity-0 overflow-hidden"
                                        }`}
                                      >
                                        <ul>
                                          <li className="px-4 py-1 hover:text-[#00c292]">
                                            <Link to="/admin/profile">Profile</Link>
                                          </li>
                                          <li className="px-3 py-1 hover:text-[#00c292]">
                                           <Link to={'/login'} className="text-red-500"><i class='bx bx-log-out'></i> Logout</Link>
                                          </li>
                                        </ul>
                                      </div>
                                    )}
                                  </li>
                                </ul>
                              </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto py-4">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
          <div className="flex justify-between items-center">
              <h1>My Profile </h1>
              <div className="flex text-sm gap-2">
               <Link to={'/adminHome'}>Home</Link> <span>/</span>
               <p className="text-[#00c292]">My Profile</p>
              </div>
            </div>
          </div>


          <div className="flex lg:flex-wrap-reverse lg:m-auto gap-10 w-[100%] p-10">
            {/* form */}
          <div className="w-[65%] lg:w-[100%] bg-white lg:m-auto p-5 rounded-lg shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-4">
      {/* Company Name */}
      <div>
        <label htmlFor="companyName" className="block text-gray-700 font-medium">
          Company Name
        </label>
        <input
          type="text"
          value={companyName}
          onChange={(e)=>setcompanyName(e.target.value)}
          id="companyName"
          name="company_name"
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Enter company name"
        />
      </div>

      {/* Email */}
      <div>
        <label htmlFor="email" className="block text-gray-700 font-medium">
          Email
        </label>
        <input
          type="email"
          id="email"
         value={email}
          onChange={(e)=>setEmail(e.target.value)}
          name="email"
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Enter email"
        />
      </div>

      {/* Phone No */}
      <div>
        <label htmlFor="phone" className="block text-gray-700 font-medium">
          Phone No
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={Phone}
          onChange={(e)=>setPhone(e.target.value)}
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Enter phone number"
        />
      </div>

      {/* Address */}
      <div>
        <label htmlFor="address" className="block text-gray-700 font-medium">
          Address
        </label>
        <textarea
          id="address"
          name="address"
          rows="3"
          value={Address}
          onChange={(e)=>setAddress(e.target.value)}
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Enter address"
        />
      </div>

      {/* New Password */}
      <div>
        <label htmlFor="oldPassword" className="block text-gray-700 font-medium">
          Old Password
        </label>
        <input
          type="password"
          id="oldPassword"
          name="oldPassword"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Enter Old password"
        />
      </div>

      {/* Confirm Password */}
      <div>
        <label htmlFor="NewPassword" className="block text-gray-700 font-medium">
          New Password
        </label>
        <input
          type="password"
          id="NewPassword"
          name="NewPassword"
          value={NewPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
          placeholder="Confirm new password"
        />
      </div>

      <div>
        <label htmlFor="phone" className="block text-gray-700 font-medium">
          Upload Image
        </label>
        <input
          id="image"
          type="file"
          name="image"
          onChange={(e)=>setImage(e.target.files[0])}
          className="w-full mt-1 p-2 border border-gray-300 rounded-lg"
        />
      </div>

      {/* Update Profile Button */}
      <div className="text-center pt-4">
        <button
        onClick={(e) => { e.preventDefault(); handleSubmit() }} 
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-all"
        >
          Update Profile
        </button>
      </div>
    </form>
</div>



              {/* Image */}
              <div className="bg-white lg:m-auto lg:w-[100%] h-[350px] p-5 w-[35%]">
                <div className="p-5 m-auto">
                    <img src={ci} className="w-[200px] h-[180px] m-auto shadow-lg border border-cyan-400 rounded-full" alt="" />
                </div>
                <h1 className="mt-2 text-center font-bold text-gray-600 text-xl italic">{user.company_name}</h1>
                <p className="text-center mt-2 text-gray-600">{user.address}</p>
              </div>

          </div>
         
        </div>
      </div>
    </div>
  );
}
